import { render } from "./SVGDecoration.vue?vue&type=template&id=a9d8ec26"
import script from "./SVGDecoration.vue?vue&type=script&lang=js"
export * from "./SVGDecoration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__